import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useCallType, CallType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<CallType>
      useData={useCallType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
